import getRandomInteger from '../rng/getRandomInteger'
import { MAX_STATE_ONLINE_ID_VALUE, MIN_STATE_ONLINE_ID_VALUE } from './StateOnlineId.type'

export default function randomStateIdValue() {
  return getRandomInteger(MIN_STATE_ONLINE_ID_VALUE, MAX_STATE_ONLINE_ID_VALUE)
}
